import React, { useEffect, useState } from "react";
import { getData, postData } from '../middleware/apiMiddleware';
import s from './ItemTextType.module.css';
import { useNavigate } from "react-router-dom";
import { TextTypeList } from '../middleware/MyConstant';

export default function ItemTextType(prop) {	
  const navigate = useNavigate();
  const itemId = prop.itemId;

  // State holds array of objects ([{"text_type":"..."}])
  const [itemTextTypes, setItemTextTypes] = useState([]); 

  // Fetch selected text types (removed all isLoading logic)
  const fetchData = async () => {
    try {
      const res = await getData(`item/listTextTypeByitemId?itemId=${itemId}`, navigate);
      setItemTextTypes(res.data || []); 
    } catch (error) {
      console.error("Failed to fetch text types:", error);
    }
  };

  // Add text type (unchanged core logic)
  const addTextType = async (textType) => {
    const obj = { itemId, textType };
    await postData("item/addTextType", obj, navigate);
    fetchData();
  };

  // Remove text type (unchanged core logic)
  const removeTextType = async (textType) => {
    const obj = { itemId, textType };
    await postData("item/removeTextType", obj, navigate);
    fetchData();
  };

  // Initial data fetch
  useEffect(() => {
    if (itemId) fetchData();
  }, [itemId]);

  // Extract text_type strings for filtering
  const selectedTextTypeStrings = itemTextTypes.map(item => item.text_type);
  
  // Filter available (unselected) text types
  const availableTextTypes = TextTypeList.filter(
    type => !selectedTextTypeStrings.includes(type)
  );

  return (
    <div className={s.container}>
      <h3 className={s.sectionTitle}>Item Text Types</h3>

      <div className={s.selectedSection}>
        <h4 className={s.subtitle}>Selected Types:</h4>
        {itemTextTypes.length === 0 ? (
          <span className={s.emptyText}>No text types selected yet</span>
        ) : (
          <div className={s.selectedTags}>
            {itemTextTypes.map((item, index) => (
              <div key={`${item.text_type}-${index}`} className={s.selectedTag}>
                <span className={s.tagText}>{item.text_type}</span>
                <button
                  className={s.removeButton}
                  onClick={() => removeTextType(item.text_type)}
                  aria-label={`Remove ${item.text_type}`}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={s.availableSection}>
        <h4 className={s.subtitle}>Available Types:</h4>
        {availableTextTypes.length === 0 ? (
          <span className={s.emptyText}>All text types are selected</span>
        ) : (
          <div className={s.availableButtons}>
            {availableTextTypes.map((type) => (
              <button
                key={type}
                className={s.addButton}
                onClick={() => addTextType(type)}
              >
                {type}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}